const colors = {
  primary: 'yellow',
  secondary: 'black',
  tertiary: 'black',
  quaternary: 'black',
  text: 'yellow',
  invertedText: 'black',
  textLightGray: 'yellow',
  gray: 'yellow',
  darkblue: 'black',
  darkArea: 'black',
  eventArea: 'black',
  success: 'yellow',
  danger: 'yellow',
};

export default colors;
